module.exports = __webpack_public_path__ + "img/pic_new_features_6.942c19f7.png";